import { useEffect, useState } from "react";
import { useLocation, useNavigate, useBlocker } from "react-router-dom";
import { TwConfirmDialog } from "./TwDialogs";

export default function TwNavigationGuard({ when, onConfirm, onClose, dialogTitle = "", dialogMessage = "", btnSubmitText = "Yes", btnCloseText = "No", children }) {
     const location = useLocation();
     const navigate = useNavigate();
     const [nextLocation, setNextLocation] = useState(null);
     const [showPrompt, setShowPrompt] = useState(false);

     const blocker = useBlocker(when());

     useEffect(() => {
          if (blocker.state === "blocked") {
               setNextLocation(blocker.location);
               setShowPrompt(true);
          }
     }, [blocker]);

     const handleYes = async () => {
          setShowPrompt(false);
          if (onConfirm) await onConfirm();
          blocker.proceed(); // let the navigation happen
     };

     const handleNo = async () => {
          setShowPrompt(false);
          setNextLocation(null);
          if (onClose) {
               if (await onClose()) {
                    blocker.proceed(); // let the navigation happen
               }
          }
          blocker.reset(); // cancel navigation
     };

     return (
          <>
               {children}
               {showPrompt && (
                    <TwConfirmDialog
                         dialogOpen={showPrompt}
                         btnCloseText={btnCloseText}
                         btnConfirmText={btnSubmitText}
                         dialogType="warning"
                         dialogTitle={dialogTitle}
                         dialogMessage={dialogMessage}
                         isCrossCloseBtn={false}
                         onClose={handleNo}
                         onConfirm={handleYes}
                    />
               )}
          </>
     );
     return (
          <>
               {children}
               {showPrompt && (
                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/50 z-50">
                         <div className="bg-white p-6 rounded shadow-lg text-center">
                              <p className="mb-4">Are you sure you want to leave this page?</p>
                              <div className="flex justify-center space-x-4">
                                   <button onClick={handleYes} className="px-4 py-2 bg-blue-600 text-white rounded">Yes</button>
                                   <button onClick={handleNo} className="px-4 py-2 bg-gray-300 rounded">No</button>
                              </div>
                         </div>
                    </div>
               )}
          </>
     );
}
